export default {
    basePlan: 'Căn cứ dự toán Ngân sách',
    additionalBudget: 'Bổ sung cho Ngân sách',
    paymentBudget: 'Chi Ngân sách (Cấp)',
    account: 'Tài khoản',
    project: 'Mã CTMT, DA',
    projectTitle: 'Mã chương trình mục tiêu, dự án',
    synAccounting: 'Đồng thời hạch toán số thu bổ sung',
    receiptBudget: 'Cho Ngân sách (Cấp)',
    organBudgetCode: 'Mã TCNS',
    organBudgetCodeTitle: 'Mã tổ chức ngân sách',
    KBNNNote: 'Phần KBNN ghi',
    debitAccount: 'Nợ TK',
    debitAccountTitle: 'Nợ tài khoản',
    creditAccount: 'Có TK',
    creditAccountTitle: 'Có tài khoản',
    localityCode: 'Mã ĐBHC',
    localityCodeTitle: 'Mã địa bàn hành chính',
    viewDetails: 'Hiển thị diễn giải chi tiết ở trên',
    viewDetailsBelow: 'Hiển thị diễn giải chi tiết ở dưới',
    dataToDetails: 'Lên số liệu vào phần Theo chi tiết',
    generalTab: 'Thông tin chung',
    detailAmount: 'Chi tiết số tiền'
};
